import { Card, Empty, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { convertToCompanyTimezoneObject } from "../../../lib/functions";
import { resolveStatusColor } from "../crmDashboardUtils";

const RecentLeads = ({ leads = [], isAdmin }) => {
  const navigate = useNavigate();

  return (
    <Card className="crm-card" variant="borderless">
      <div className="crm-card-head">
        <div>
          <div className="crm-card-title">Recent leads</div>
          <div className="crm-card-sub">Newest additions</div>
        </div>
        <button type="button" className="crm-link" onClick={() => navigate("/crm/leads")}>
          View all
        </button>
      </div>

      {!leads.length ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No leads yet" style={{ padding: "32px 0" }} />
      ) : (
        <ul className="crm-rows">
          {leads.map((lead) => {
            const meta = [
              lead.source,
              isAdmin ? lead.assignee : null,
              lead.created_date
                ? convertToCompanyTimezoneObject(lead.created_date).format("DD MMM, hh:mm A")
                : null,
            ].filter(Boolean);

            return (
              <li
                key={lead.id}
                className="crm-row clickable"
                onClick={() => navigate(`/crm/leads/${lead.id}`)}
              >
                <span className="crm-avatar">{(lead.name || "?")[0].toUpperCase()}</span>
                <span className="crm-row-main">
                  <span className="crm-row-title">{lead.name}</span>
                  <span className="crm-row-meta">{meta.join(" · ")}</span>
                </span>
                {lead.status && (
                  <Tag
                    color={resolveStatusColor(lead.status_color)}
                    style={{ margin: 0, borderRadius: 12, border: "none" }}
                  >
                    {lead.status}
                  </Tag>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
};

export default RecentLeads;
